import { Play, Pause, Volume2, VolumeX } from 'lucide-react'
import { useEditorStore } from '../../../store/editorStore'
import { useUiStore } from '../../../store/uiStore'
import { formatTime } from '../../../lib/time'

export function PlaybackBar({ totalSec }: { totalSec: number }) {
  const { currentSec, isPlaying } = useEditorStore((s) => s.playback)
  const togglePlaying = useEditorStore((s) => s.togglePlaying)
  const setPlayhead = useEditorStore((s) => s.setPlayhead)
  // P10-1 担当C: プレビューの BGM/SFX ミュート（usePreviewAudio.ts が購読）。
  const previewMuted = useUiStore((s) => s.previewMuted)
  const togglePreviewMuted = useUiStore((s) => s.togglePreviewMuted)

  return (
    <div className="flex items-center gap-2.5 px-1 pt-2" data-testid="playback-bar">
      <button
        onClick={togglePlaying}
        disabled={totalSec === 0}
        data-testid="btn-play-pause"
        className="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 disabled:opacity-30 flex items-center justify-center shrink-0"
      >
        {isPlaying ? <Pause size={13} fill="currentColor" /> : <Play size={13} fill="currentColor" className="ml-0.5" />}
      </button>
      {/* Bug fix (2026-09-05, see Playhead.tsx's doc comment): display-clamp
          against `totalSec` — same reasoning as the scrub-bar's own `value`
          just below, which already did this — so a stale `currentSec` left
          behind by an edit that shrank the timeline (not just the
          project-switch/自動編集-rerun cases, which now reset it outright)
          can never show a current-time later than the total-time next to it. */}
      <span className="text-[11px] tabular-nums text-text-muted w-10 text-right" data-testid="current-time">
        {formatTime(Math.min(currentSec, totalSec))}
      </span>
      <input
        type="range"
        min={0}
        max={Math.max(totalSec, 0.001)}
        step={0.01}
        value={Math.min(currentSec, totalSec)}
        disabled={totalSec === 0}
        onChange={(e) => setPlayhead(Number(e.target.value))}
        data-testid="scrub-bar"
        className="flex-1 accent-accent-red h-1 disabled:opacity-30"
      />
      <span className="text-[11px] tabular-nums text-text-faint w-10" data-testid="total-time">
        {formatTime(totalSec)}
      </span>
      <button
        onClick={togglePreviewMuted}
        data-testid="preview-mute"
        aria-label={previewMuted ? 'ミュート解除' : 'ミュート'}
        aria-pressed={previewMuted}
        className="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center shrink-0"
      >
        {previewMuted ? <VolumeX size={13} /> : <Volume2 size={13} />}
      </button>
    </div>
  )
}
